import React from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import RateContent from "./RateContent";
import {Box} from "@mui/material";

const RateContainer = () => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Box>
            <SectionHeader title={t("translation:auths.SCOPE_PRC_VIEW_RATE.name")}/>
            <RateContent readOnly={false}/>
        </Box>
    );
};

export default RateContainer;